import { render, staticRenderFns } from "./hot-subject-top.vue?vue&type=template&id=a78f7468&scoped=true"
import script from "./hot-subject-top.vue?vue&type=script&lang=js"
export * from "./hot-subject-top.vue?vue&type=script&lang=js"
import style0 from "./hot-subject-top.vue?vue&type=style&index=0&id=a78f7468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78f7468",
  null
  
)

export default component.exports